function clearObj(obj, excludeArr = [], formatProperties = { string: '', number: '', boolean: '' }) {
    const newObj = {}
    for (var key in obj) {
        if (excludeArr.includes(key)) { newObj[key] = JSON.parse(JSON.stringify(obj[key])); continue }
        switch (Object.prototype.toString.call(obj[key])) {
            case '[object Object]':
                newObj[key] = clearObj(JSON.parse(JSON.stringify(obj[key])), excludeArr, formatProperties)
                break;
            case '[object Array]':
                newObj[key] = []
                break;
            case '[object Number]':
                newObj[key] = formatProperties.hasOwnProperty('number') ? formatProperties.number : ''
                break;
            case '[object Boolean]':
                newObj[key] = formatProperties.hasOwnProperty('boolean') ? formatProperties.boolean : ''
                break;
            default:
                newObj[key] = formatProperties.hasOwnProperty('string') ? formatProperties.string : ''
                break;
        }
    }
    return newObj
}
function FloatSub(arg1,arg2){
    var r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    //动态控制精度长度
    n=(r1>=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}

/**
 * @param fn 防抖后要执行的函数
 * @param wait 延迟几秒后运行函数
 * 
 * 将Vue的this对象绑定给debounce即可在Vue中使用
 * this.$common.debounce(function(event) { console.log("调试提交") }, 500)
 */
function debounce(fn, wait) {
    var args = arguments, that = this
    wait = wait || 600
    if (window.submitTimer) { clearTimeout(window.submitTimer) }
    window.submitTimer = setTimeout(function() {
        fn.apply(that, args)
        window.submitTimer = null
    }, wait)
    window.addEventListener("beforeunload", function(event) {
        clearTimeout(window.submitTimer)
        window.submitTimer = null
    });
}

// 判断是否有管理者的权限
function hasMasterPermission() {
    return sessionStorage.getItem("role") == "master" ? true : false
}

export default { clearObj,FloatSub, debounce, hasMasterPermission }


// WEBPACK FOOTER //
// ./src/utils/common.js